import React from 'react'

function Partners() {
  return (
    <div className='nav-margin'>Partners</div>
  )
}

export default Partners